'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import createReactClass from 'create-react-class';
import toJS from 'transmute/toJS';
import valueSeq from 'transmute/valueSeq';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Url from 'urlinator/Url';
import Raven from 'Raven';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import BookingContainer from './page/BookingContainer';
import CancelContainer from './page/CancelContainer';
import BookingSummary from './page/BookingSummary';
import Error from 'MeetingsLib/components/Error';
import { setDocumentTitle } from 'MeetingsLib/utils/utils';
import { trackHsFormViews, addHsTrackingCode, trackLibVersionInNewRelic } from 'MeetingsLib/utils/analytics';
import hubspotGTMContainer from 'MeetingsLib/utils/hubspotGTMContainer';
import convertAnalyticsContainer from 'MeetingsLib/utils/convertAnalyticsContainer';
import { initializeMeetingsLibTracker } from 'MeetingsLib/tracking/UsageTracker';
import { getBookInfoError as getBookInfoErrorSelector, isInvalidDomainError as isInvalidDomainErrorSelector, getRescheduleError as getRescheduleErrorSelector } from 'MeetingsLib/selectors/NetworkErrorSelector';
import { meetingCreationSuccess as meetingCreationSuccessSelector, bookingPageLoading as bookingPageLoadingSelector, shouldRenderBookingPage as shouldRenderBookingPageSelector, fetchBookInfoFailed as fetchBookInfoFailedSelector, meetingCreationFailed as meetingCreationFailedSelector, availabilityFetchFailed as availabilityFetchFailedSelector, availabilityFetchSuccess as availabilityFetchSuccessSelector, meetingsUserFetchStarted as meetingsUserFetchStartedSelector, meetingsUserFetchSuccess as meetingsUserFetchSuccessSelector, isSubmittingMeeting as isSubmittingMeetingSelector, meetingRescheduleSuccess as meetingRescheduleSuccessSelector, meetingRescheduleFailed as meetingRescheduleFailedSelector } from 'MeetingsLib/selectors/RequestStatusSelectors';
import { getCustomParams as getCustomParamsSelector, getUserProfile as getUserProfileSelector, getDisplayInfo as getDisplayInfoSelector, getWelcomeScreenInfo as getWelcomeScreenInfoSelector, getBookInfo as getBookInfoSelector, getOffline as getOfflineSelector } from 'MeetingsLib/selectors/BookInfoSelectors';
import { getActiveLocale } from 'MeetingsLib/selectors/LocalizationSelectors';
import * as FormActions from 'MeetingsLib/redux/actions/FormActions';
import * as BookActions from 'MeetingsLib/redux/actions/BookActions';
import * as AvailabilityActions from 'MeetingsLib/redux/actions/AvailabilityActions';
import * as UIActions from 'MeetingsLib/redux/actions/UIActions';
import Branding from 'MeetingsBase/models/Branding';
import UserProfile from 'MeetingsBase/models/UserProfile';
import DisplayInfo from 'MeetingsBase/models/DisplayInfo';
import BookingLifecycleRecord from 'MeetingsLib/models/BookingLifecycle';
import { LINK_TYPES } from 'MeetingsBase/constants/enums';
import WelcomeScreenInfo from 'MeetingsBase/models/WelcomeScreenInfo';
var App = createReactClass({
  displayName: "App",
  propTypes: {
    // passable props
    branding: PropTypes.instanceOf(Branding).isRequired,
    displayInfo: PropTypes.instanceOf(DisplayInfo).isRequired,
    hideLogo: PropTypes.bool,
    changeLocale: PropTypes.func,
    DatePickerMarker: PropTypes.func,
    TimePickerMarker: PropTypes.func,
    EmailFormMarker: PropTypes.func,
    NotFoundMarker: PropTypes.func,
    ErrorMarker: PropTypes.func,
    // props from store (don't change these)
    bookInfoError: PropTypes.string,
    bookingLifecycle: PropTypes.instanceOf(BookingLifecycleRecord).isRequired,
    companyName: PropTypes.string,
    embedded: PropTypes.bool.isRequired,
    isInvalidDomainError: PropTypes.bool,
    isSalesStarter: PropTypes.bool,
    offline: PropTypes.bool,
    activeLocale: PropTypes.string,
    onSuccess: PropTypes.func.isRequired,
    onFailure: PropTypes.func.isRequired,
    parentPageHSAnalyticsInfo: PropTypes.instanceOf(Object),
    portalId: PropTypes.number.isRequired,
    profile: PropTypes.instanceOf(UserProfile).isRequired,
    userTimezone: PropTypes.string,
    welcomeScreenInfo: PropTypes.instanceOf(WelcomeScreenInfo).isRequired,
    formGuid: PropTypes.string,
    linkType: PropTypes.oneOf(valueSeq(LINK_TYPES).toArray()),
    contentTracking: PropTypes.object,
    redirectUrl: PropTypes.string,
    allowRedirect: PropTypes.bool.isRequired,
    userSlug: PropTypes.string,
    isRescheduling: PropTypes.bool,
    meetingChangeId: PropTypes.string,
    meetingRescheduleError: PropTypes.string,
    // action dispatchers
    getAvailability: PropTypes.func.isRequired,
    fetchEventDetails: PropTypes.func.isRequired,
    // request statuses
    bookingPageLoading: PropTypes.bool.isRequired,
    submittingMeeting: PropTypes.bool.isRequired,
    shouldRenderBookingPage: PropTypes.bool.isRequired,
    meetingCreationSuccess: PropTypes.bool.isRequired,
    meetingRescheduleFailed: PropTypes.bool,
    meetingRescheduleSuccess: PropTypes.bool.isRequired,
    fetchBookInfoFailed: PropTypes.bool.isRequired,
    meetingsUserFetchStarted: PropTypes.bool.isRequired,
    meetingsUserFetchSuccess: PropTypes.bool.isRequired,
    meetingCreationFailed: PropTypes.bool.isRequired,
    availabilityFetchFailed: PropTypes.bool.isRequired,
    availabilityFetchSuccess: PropTypes.bool.isRequired,
    initTrackingForMeetings: PropTypes.bool.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      DatePickerMarker: function DatePickerMarker() {
        return null;
      },
      TimePickerMarker: function TimePickerMarker() {
        return null;
      },
      EmailFormMarker: function EmailFormMarker() {
        return null;
      },
      NotFoundMarker: function NotFoundMarker() {
        return null;
      },
      ErrorMarker: function ErrorMarker() {
        return null;
      }
    };
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    var _this$props = this.props,
        getAvailability = _this$props.getAvailability,
        changeLocale = _this$props.changeLocale;
    getAvailability(changeLocale);
    trackLibVersionInNewRelic();
  },
  componentDidMount: function componentDidMount() {
    var _this$props2 = this.props,
        fetchEventDetails = _this$props2.fetchEventDetails,
        userSlug = _this$props2.userSlug,
        isRescheduling = _this$props2.isRescheduling,
        meetingChangeId = _this$props2.meetingChangeId;

    if (isRescheduling) {
      fetchEventDetails(userSlug, meetingChangeId);
    }
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    var _this$props3 = this.props,
        previousFormGuid = _this$props3.formGuid,
        initTrackingForMeetings = _this$props3.initTrackingForMeetings,
        __oldPortalId = _this$props3.portalId,
        __oldCompanyName = _this$props3.companyName,
        oldAvailabilityFetchSuccess = _this$props3.availabilityFetchSuccess,
        __oldLinkType = _this$props3.linkType,
        __oldContentTracking = _this$props3.contentTracking,
        __activeLocale = _this$props3.activeLocale;
    var profile = nextProps.profile,
        headline = nextProps.displayInfo.headline,
        availabilityFetchSuccess = nextProps.availabilityFetchSuccess,
        portalId = nextProps.portalId,
        linkType = nextProps.linkType,
        nextFormGuid = nextProps.formGuid,
        nextContentTracking = nextProps.contentTracking,
        embedded = nextProps.embedded,
        companyName = nextProps.companyName,
        activeLocale = nextProps.activeLocale;
    var availabilityInfoLoaded = availabilityFetchSuccess && availabilityFetchSuccess !== oldAvailabilityFetchSuccess;

    if (availabilityInfoLoaded) {
      hubspotGTMContainer(portalId);
      convertAnalyticsContainer(portalId);
    }

    if (availabilityInfoLoaded && initTrackingForMeetings) {
      initializeMeetingsLibTracker(nextProps.profile.email, portalId, embedded, activeLocale);
    }

    var shouldSetDocumentTitle = this.shouldSetDocumentTitle(availabilityFetchSuccess, embedded);

    if (shouldSetDocumentTitle) {
      setDocumentTitle(headline, linkType, companyName, profile);
    }

    var shouldTrackFormViews = this.shouldTrackFormViews(previousFormGuid, nextFormGuid);

    if (shouldTrackFormViews && availabilityFetchSuccess) {
      trackHsFormViews(nextFormGuid, portalId, Object.assign({}, this.props.parentPageHSAnalyticsInfo, {}, nextContentTracking), embedded);
      addHsTrackingCode(portalId, embedded);
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    var availabilityFetchDidFail = prevProps.availabilityFetchFailed;
    var _this$props4 = this.props,
        availabilityFetchFailed = _this$props4.availabilityFetchFailed,
        bookInfoError = _this$props4.bookInfoError;

    if (!availabilityFetchDidFail && availabilityFetchFailed) {
      Raven.captureBreadcrumb({
        message: 'Public availability info fetch failed!',
        data: {
          error: bookInfoError
        }
      });
    }
  },
  shouldSetDocumentTitle: function shouldSetDocumentTitle(availabilityFetchSuccess, embedded) {
    var meetingsLinkExists = availabilityFetchSuccess;
    return !embedded && meetingsLinkExists;
  },
  shouldTrackFormViews: function shouldTrackFormViews(previousFormGuid, nextFormGuid) {
    return previousFormGuid !== nextFormGuid;
  },
  isCancelPage: function isCancelPage() {
    var embedded = this.props.embedded;
    var url = new Url(window.location);
    var isCancel = url.paramValue('cancel') === 'true';
    var meetingChangeId = url.paramValue('meetingChangeId');
    return !embedded && isCancel && !!meetingChangeId;
  },
  renderBookingContainer: function renderBookingContainer() {
    var _this$props5 = this.props,
        branding = _this$props5.branding,
        hideLogo = _this$props5.hideLogo,
        profile = _this$props5.profile,
        submittingMeeting = _this$props5.submittingMeeting,
        _this$props5$displayI = _this$props5.displayInfo,
        avatar = _this$props5$displayI.avatar,
        headline = _this$props5$displayI.headline,
        publicDisplayAvatarOption = _this$props5$displayI.publicDisplayAvatarOption,
        companyAvatar = _this$props5$displayI.companyAvatar,
        welcomeScreenInfo = _this$props5.welcomeScreenInfo,
        DatePickerMarker = _this$props5.DatePickerMarker,
        TimePickerMarker = _this$props5.TimePickerMarker,
        EmailFormMarker = _this$props5.EmailFormMarker;
    return /*#__PURE__*/_jsx(BookingContainer, {
      avatar: avatar,
      companyAvatar: companyAvatar,
      displayAvatarOption: publicDisplayAvatarOption,
      branding: branding,
      headline: headline,
      hideLogo: hideLogo,
      profile: profile,
      submittingMeeting: submittingMeeting,
      welcomeScreenInfo: welcomeScreenInfo,
      DatePickerMarker: DatePickerMarker,
      TimePickerMarker: TimePickerMarker,
      EmailFormMarker: EmailFormMarker
    });
  },
  renderSummary: function renderSummary() {
    var _this = this;

    var _this$props6 = this.props,
        bookingLifecycle = _this$props6.bookingLifecycle,
        branding = _this$props6.branding,
        _this$props6$displayI = _this$props6.displayInfo,
        avatar = _this$props6$displayI.avatar,
        headline = _this$props6$displayI.headline,
        embedded = _this$props6.embedded,
        isSalesStarter = _this$props6.isSalesStarter,
        offline = _this$props6.offline,
        profile = _this$props6.profile,
        userTimezone = _this$props6.userTimezone,
        redirectUrl = _this$props6.redirectUrl,
        allowRedirect = _this$props6.allowRedirect,
        portalId = _this$props6.portalId;
    var bookedDateTime = bookingLifecycle.postResponse.get('timerange').start;
    return /*#__PURE__*/_jsx(BookingSummary, {
      bookingLifecycle: bookingLifecycle,
      avatar: avatar,
      bookedDateTime: bookedDateTime,
      branding: branding,
      embedded: embedded,
      headline: headline,
      isSalesStarter: isSalesStarter,
      offline: offline,
      profile: profile,
      userTimezone: userTimezone,
      redirectUrl: redirectUrl,
      allowRedirect: allowRedirect,
      onSuccess: function onSuccess() {
        parent.postMessage({
          meetingBookSucceeded: true
        }, '*');

        _this.props.onSuccess(toJS(bookingLifecycle.postResponse));
      },
      portalId: portalId
    });
  },
  renderError: function renderError(profile) {
    var _this2 = this;

    var _this$props7 = this.props,
        bookingLifecycle = _this$props7.bookingLifecycle,
        fetchBookInfoFailed = _this$props7.fetchBookInfoFailed,
        meetingsUserFetchSuccess = _this$props7.meetingsUserFetchSuccess,
        meetingCreationFailed = _this$props7.meetingCreationFailed,
        meetingRescheduleFailed = _this$props7.meetingRescheduleFailed,
        bookInfoError = _this$props7.bookInfoError,
        isInvalidDomainError = _this$props7.isInvalidDomainError,
        NotFoundMarker = _this$props7.NotFoundMarker,
        meetingRescheduleError = _this$props7.meetingRescheduleError,
        ErrorMarker = _this$props7.ErrorMarker;
    return /*#__PURE__*/_jsx(Error, {
      profile: profile,
      bookInfoError: bookInfoError,
      isInvalidDomainError: isInvalidDomainError,
      meetingCreationFailed: meetingCreationFailed,
      meetingRescheduleFailed: meetingRescheduleFailed,
      meetingRescheduleError: meetingRescheduleError,
      bookInfoFailed: fetchBookInfoFailed,
      meetingsUserFetchSuccess: meetingsUserFetchSuccess,
      NotFoundMarker: NotFoundMarker,
      ErrorMarker: ErrorMarker,
      onFailure: function onFailure() {
        parent.postMessage({
          meetingBookFailed: true
        }, '*');

        _this2.props.onFailure(toJS(bookingLifecycle.postResponse));
      }
    });
  },
  renderApplication: function renderApplication() {
    var _this$props8 = this.props,
        profile = _this$props8.profile,
        bookingPageLoading = _this$props8.bookingPageLoading,
        meetingsUserFetchStarted = _this$props8.meetingsUserFetchStarted,
        shouldRenderBookingPage = _this$props8.shouldRenderBookingPage,
        meetingCreationSuccess = _this$props8.meetingCreationSuccess,
        meetingRescheduleSuccess = _this$props8.meetingRescheduleSuccess,
        availabilityFetchFailed = _this$props8.availabilityFetchFailed;

    if (shouldRenderBookingPage && !availabilityFetchFailed) {
      if (this.isCancelPage()) {
        return /*#__PURE__*/_jsx(CancelContainer, {
          profile: profile
        });
      }

      return this.renderBookingContainer();
    }

    if (bookingPageLoading || meetingsUserFetchStarted) {
      return /*#__PURE__*/_jsx(UILoadingSpinner, {
        layout: "centered",
        className: "m-all-0 height-100"
      });
    }

    if (meetingCreationSuccess || meetingRescheduleSuccess) {
      return this.renderSummary();
    }

    return this.renderError(profile);
  },
  render: function render() {
    var embedded = this.props.embedded;
    var className = 'meetings-lib' + (embedded ? " embedded" : "");
    return /*#__PURE__*/_jsx("div", {
      className: className,
      children: this.renderApplication()
    });
  }
});
export default connect(function (state, props) {
  return {
    linkType: getBookInfoSelector(state).linkType,
    formGuid: getBookInfoSelector(state).formGuid,
    contentTracking: getBookInfoSelector(state).contentTracking,
    offline: getOfflineSelector(state),
    branding: props.branding || state.branding,
    portalId: state.portalId,
    profile: getUserProfileSelector(state, props),
    companyName: state.companyName,
    bookingLifecycle: state.bookingLifecycle,
    userTimezone: state.userTimezone,
    bookInfoError: getBookInfoErrorSelector(state),
    isInvalidDomainError: isInvalidDomainErrorSelector(state),
    initTrackingForMeetings: state.initTrackingForMeetings,
    activeLocale: getActiveLocale(state),
    onSuccess: state.onSuccess,
    onFailure: state.onFailure,
    embedded: state.embedded,
    displayInfo: getDisplayInfoSelector(state, props),
    welcomeScreenInfo: getWelcomeScreenInfoSelector(state),
    redirectUrl: getCustomParamsSelector(state).redirectUrl,
    allowRedirect: state.allowRedirect,
    isSalesStarter: state.isSalesStarter,
    parentPageHSAnalyticsInfo: state.parentPageHSAnalyticsInfo,
    // request statuses
    meetingCreationSuccess: meetingCreationSuccessSelector(state),
    meetingRescheduleSuccess: meetingRescheduleSuccessSelector(state),
    bookingPageLoading: bookingPageLoadingSelector(state),
    shouldRenderBookingPage: shouldRenderBookingPageSelector(state),
    fetchBookInfoFailed: fetchBookInfoFailedSelector(state),
    meetingCreationFailed: meetingCreationFailedSelector(state),
    meetingRescheduleFailed: meetingRescheduleFailedSelector(state),
    meetingRescheduleError: getRescheduleErrorSelector(state),
    availabilityFetchFailed: availabilityFetchFailedSelector(state),
    availabilityFetchSuccess: availabilityFetchSuccessSelector(state),
    meetingsUserFetchStarted: meetingsUserFetchStartedSelector(state),
    meetingsUserFetchSuccess: meetingsUserFetchSuccessSelector(state),
    submittingMeeting: isSubmittingMeetingSelector(state),
    userSlug: state.userSlug,
    isRescheduling: state.isRescheduling,
    meetingChangeId: state.meetingChangeId
  };
}, Object.assign({}, FormActions, {}, BookActions, {}, UIActions, {}, AvailabilityActions))(App);